<template>
  <div
    class="product-box elevation-3"
    :class="{
      'cs-pointer': canSelect
    }"
    style="border-radius: 0.625rem;">
    <v-skeleton-loader
      v-if="loading"
      elevation="3"
      height="180"
      type="image" />
    <div
      v-else
      class="product-content"
      @click="canSelect ? $emit('select', id) : () => {}">
      <img
        :src="imageUrl"
        :lazy-src="lazyImageUrl" />
      <div class="flex-grow-1 pa-2 d-flex flex-column">
        <div class="d-flex flex-row align-start justify-space-between">
          <span class="font-weight-bold">
            {{ name }}
          </span>
          <v-btn
            v-if="removeAble && !loading"
            color="error"
            icon
            small
            @click="$emit('remove', index)">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </div>
        <span class="mt-1">
          {{ model }}
        </span>
        <span>
          Colors:
          <v-chip
            v-for="(color, cIndex) in colors"
            :key="`product-${id}-color-${cIndex}`"
            class="ma-1 capitalize"
            color="teal"
            text-color="white"
            small
            label>
            {{ color }}
          </v-chip>
        </span>
        <span>
          Sizes:
          <v-chip
            v-for="(size, sIndex) in sizes"
            :key="`product-${id}-size-${sIndex}`"
            class="ma-1"
            color="teal"
            text-color="white"
            small
            label>
            {{ size.toUpperCase() }}
          </v-chip>
        </span>
        <span class="mt-auto font-weight-bold">
          Price: {{ price | showFullPriceFormat() }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import NoPicture from '@/assets/image/no_picture_available.png'

export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    model: {
      type: String,
      default: ''
    },
    photoUrls: {
      type: Array,
      default: () => []
    },
    colors: {
      type: Array,
      default: () => []
    },
    sizes: {
      type: Array,
      default: () => []
    },
    price: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    canSelect: {
      type: Boolean,
      default: false
    },
    removeAble: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imageUrl () {
      return this.photoUrls?.length ? `${this.replaceURL(this.photoUrls[0])}?fm=webp&q=80&h=180` : NoPicture
    },
    lazyImageUrl () {
      return this.photoUrls?.length ? `${this.replaceURL(this.photoUrls[0])}?fm=webp&q=80&w=2&h=2` : NoPicture
    },
    splitModel () {
      const splitted = this.name.split('-')
      return splitted.length ? splitted[splitted.length - 1].trim() : this.name
    }
  },
  methods: {
    replaceURL (value) {
      // return value.replace(process.env.VUE_APP_S3_URL, process.env.VUE_APP_S3_IMGIX)
      return this.$convertImgix(value.replace(`${process.env.VUE_APP_S3_IMGIX}/`, process.env.VUE_APP_S3_URL))
    }
  }
}
</script>

<style scoped>
.cs-pointer {
  cursor: pointer;
}
.product-box {
  position: relative;
  width: 100%;
  height: 180px;
  /* background-color: #BEBEBE; */
  overflow-x: hidden;
}
.product-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}
.product-content img {
  height: 180px;
  aspect-ratio: 2/3;
  object-fit: cover;
}
.product-text {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  font-size: 11px;
  text-align: center;
  border-radius: 1rem;
  padding: 0.2rem 0.5rem;
  background-color: rgba(5, 247, 142, 0.7);
}
</style>
